const templates = {
    defaultScript: '/*\n' +
'В данном скрипте определяются 2 важные вещи - параметры шаблона и постобработка результатов, полученных от модели LLM.\n' +
'У каждого шаблона использования LLM могут быть параметры - переменные, которые будут определены в коде системы.\n' +
'Например, шаблон для формирования ключевых слов запроса на основе анализа релевантных текстов документов может\n' +
'содержать один параметр TEXTS, в котором будет задан текст из документов, на основе которых надо формировать \n' +
'ключевые слова. А шаблон для формирования ответа на вопрос по документу будет содержать 2 поля - \n' +
'TEXT (текст документа) и QUESTION (вопрос, заданный пользователем)\n' +
'\n' +
'Параметры можно использовать как в системном, так и в пользовательском промте LLM, например, для формирования\n' +
'ответа на вопрос по документу можно задать следующий системный промт - \n' +
'"Ты - системный аналитик, вдумчиво отвечающий  на вопросы от пользователя"\n' +
'\n' +
'и пользовательский промт - \n' +
'"Ответь на вопрос пользователя по заданному документу. Если вопрос пользователя пуст - дай краткую аннотацию документа\n' +
'Вопрос: ${QUESTION}\n' +
'Текст документа: ${TEXT}"\n' +
'\n' +
'Все параметры являются текстовыми. Смысл, количество и имена параметров определяются совместно программистом, \n' +
'создающим функционал, где требуются шаблоны и аналитиком, который будет настраивать промты для реализации данного \n' +
'функционала. Программист зашивает имена и логику содержимого параметров в коде, аналитик тестирует шаблон вызова,\n' +
'используя эти имена и тексты параметров, приближенные к тем, которые будут формироваться автоматически \n' +
'внутри программного кода.\n' +
'\n' +
'Ниже приведен пример таких параметров. Раскомментарьте его или скопируйте и измените текст данного примера. \n' +
'Параметры должны помещаться в начале скрипта. \n' +
'\n' +
'@Parameter(description=\'Вопрос пользователя\')\n' +
'def QUESTION = \'\'\n' +
'\n' +
'@Parameter(description=\'Текст документа\')\n' +
'def TEXT = \'\'\n' +
'\n' +
'Далее идет описание того, что можно делать на стадии постпроцессинга.\n' +
'Постпроцессинг необходим, чтобы сконвертировать ответ, полученный от LLM, в объект, который необходим программисту для функционала\n' +
'Проблема с ответом LLM заключается в том, что она может, вообще говоря, возвратить любой текстовый ответ и \n' +
'необходимо приложить определенные усилия, чтобы из этого ответа получить нужный нам объект в нужном нам формате.\n' +
'\n' +
'В скрипт постпроцессинга передается объект response, в котором есть 3 поля\n' +
'boolean ok - показывает, успешно ли прошло обращение к LLM.  \n' +
'String service - полный ответ от LLM, полученный по сети. Для LLM, работающих по протоколу chat/completions \n' +
'- это json, содержащий большое количество полей, в частности текстовый ответ LLM. Но формирование его значения\n' +
'  не зашито в код платформы, а настраивается в скрипте LLM, поэтому при желании этом можно изменить.\n' +
'String text - текстовый ответ от LLM. Для LLM, работающих по протоколу chat/completions \n' +
'- это значение поля choices[0].message.content. Однако, в скрипте LLM можно изменить значение этого поля.\n' +
'\n' +
'Возвратить скрипт может любой объект. Например, строку, массив строк или HashMap с разными ключами.\n' +
'Что скрипт должен возвратить - определяется совместно программистом и системным аналитиком в зависимости от \n' +
'разрабатываемого функционала. Результат работы скрипта можно проверить непосредственно из интерфейса\n' +
'создания-редактирования шаблона, нажав на кнопку Проверить.\n' +
'\n' +
'Ниже приведен пример такого скрипта\n' +
'\n' +
'//Пример, как можно обработать статус ответа сети\n' +
'if(!response.ok) {\n' +
'    //При желании из скрипта можно выбросить исключение. Программист, работающий с результатом выполнения скрипта\n' +
'    //должен быть готов к отлову таких исключений\n' +
'    throw new RuntimeException("Ошибка выполнения запроса: ${response.service}")\n' +
'}\n' +
'\n' +
'//Пример как можно проанализировать текстовый ответ LLM\n' +
'if(response.text?.startsWith(\'Пожары\')) {\n' +
'    return \'Пожары\'\n' +
'} else if(response.text?.startsWith(\'Котёнки\')) {\n' +
'    return \'Котёнки\'\n' +
'} else {\n' +
'    return \'Класс не определен\'\n' +
'}\n' +
'\n' +
'//Пример как можно проанализировать json, который содержит не только текстовый ответ LLM, но и дополнительные поля.\n' +
'//полный набор полей определяется конкретной LLM, и надо изучать документацию по ней.\n' +
'def serviceAsJson = response.json() //под капотом реобразует в json значение поля service. \n' +
'def thinking = serviceAsJson?.\'choices\'?.get(0)?.\'message\'?.thinking //в этом поле хранится размышление думающей LLM\n' +
'\n' +
'return response.text + "\\n" + thinking\n' +
'\n' +
'*/\n'
};

export { templates };